import { useMutation, UseMutationOptions, MutationFunction, QueryClient } from '@tanstack/react-query';
import Error from '../models/Error.model';

// export function useAppMutation<TData = unknown, TVariables = void, TContext = unknown>(
//   mutationFn: MutationFunction<TData, TVariables>,
//   options?: Omit<UseMutationOptions<TData, Error, TVariables, TContext>, 'mutationFn'>
// ) {
//   return useMutation<TData, Error, TVariables, TContext>({
//     mutationFn,
//     ...options,
//   });
// }

export default function useAppMutation<
  TData = unknown,
  TVariables = void,
  TContext = unknown
>(options: UseMutationOptions<TData, Error, TVariables, TContext>, queryClient?: QueryClient) {
  return useMutation(options, queryClient)
}